import React, { Component } from 'react';
import { matchPath } from 'react-router';
import StarRatingComponent from 'react-star-rating-component';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';

import Compressor from 'compressorjs';

import AuthService from './AuthService';
import Layout from './Layout';
import LazyCardImage from './LazyCardImage';
import constants from '../config';
import { resolveCardImage } from '../utils/resolveImage';
import AuthModalContext from '../contexts/AuthModalContext';
import { renderRarityBadge } from '../utils/rarityBadge';
import { arrangeCardsForGrid } from '../utils/arrangeGrid';
import { buildConditionsList, LEGACY_NO_FOIL_RARITIES } from '../utils/conditions';
// BUYLIST FEATURE: disabled — preserved for future use
// import BuylistTab from './BuylistTab';

import whitebox from './assets/White_square.png';

const Auth = new AuthService();
const SHARE_MIN_PRICE = constants.SHARE_MIN_PRICE || 10;
const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
const MAX_FILE_SIZE = 10 * 1024 * 1024;

var conditionMap = { 'NM': 'Near Mint', 'LP': 'Lightly Played', 'MP': 'Moderately Played' };

function formatCondition(category) {
  if (!category) return '';
  var label = category.replace(/^singles\s*/i, '').replace(/F$/, '');
  return conditionMap[label] || label;
}

function getCondition(category) {
  if (!category) return '';
  return category.replace(/^singles\s*/i, '').replace(/F$/, '');
}

function formatDate(dateStr) {
  if (!dateStr) return '';
  var d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}

class Profile extends Component {
  static contextType = AuthModalContext;

  constructor(props) {
    super(props);
    this.state = {
      id: '',
      posts: [],
      name: '',
      username: '',
      bio: '',
      profilePic: whitebox,
      backgroundPicture: '',
      isFollowing: false,
      following: [],
      followers: [],
      rating: 0,
      reviews: [],
      isSelf: false,
      loading: true,
      showItems: 20,
      createdAt: '',
      activeFilter: 'active',
      searchQuery: '',
      sortBy: 'newest',
      categoryFilter: 'all',
      foilFilter: false,
      showReviews: false,
      showAllReviews: false,
      reviewSort: 'newest',
      showBackToTop: false,
      instagram: '',
      twitter: '',
      preferredShipping: '',
      preferredPayment: '',
      locationCity: '',
      locationState: '',
      buylistCount: 0,
      followModal: null, // null = closed, 'followers' or 'following'
      followModalData: [],
      followModalLoading: false,
      viewMode: 'grid',
      editModalPost: null,
      editModalLoading: false,
      editModalSaving: false,
      editModalDeleting: false,
      editModal: {},
      editModalPhotos: [],
      editModalExistingPhotos: [],
      editModalPhotoError: '',
      editModalProcessingPhoto: false,
      editModalErrors: {},
      editModalCard: null,
      editModalCardImage: null,
      editModalShowDesc: false,
      editModalShowPhotos: false,
    };
    this.handleFollow = this.handleFollow.bind(this);
    this.handleShowMore = this.handleShowMore.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.toggleReviews = this.toggleReviews.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.profile = this.profile.bind(this);
    this.toggleShopActive = this.toggleShopActive.bind(this);
    this.handleAuthStateChanged = this.handleAuthStateChanged.bind(this);
    this.openFollowModal = this.openFollowModal.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.closeEditModal = this.closeEditModal.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleEditDelete = this.handleEditDelete.bind(this);
    this.editModalAddPhoto = this.editModalAddPhoto.bind(this);
    this.editModalRemovePhoto = this.editModalRemovePhoto.bind(this);
  }

  handleAuthStateChanged() {
    if (!Auth.getToken()) {
      this.setState({ isSelf: false });
    } else {
      // Logged in — re-check if this is the user's own shop
      var match = matchPath(this.props.history.location.pathname, {
        path: '/shop/:username',
        exact: false,
        strict: false,
      });
      if (match) {
        this.profile(match.params.username);
      }
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('authStateChanged', this.handleAuthStateChanged);
    this._handleThemeChanged = function() { this.forceUpdate(); }.bind(this);
    window.addEventListener('themeChanged', this._handleThemeChanged);
    var match = matchPath(this.props.history.location.pathname, {
      path: '/shop/:username',
      exact: false,
      strict: false,
    });
    if (match) {
      this.profile(match.params.username);
    }
    // BUYLIST FEATURE: disabled — preserved for future use
    // Support ?tab=buying query param to open Buying tab directly
    // var searchParams = new URLSearchParams(this.props.location.search);
    // var tabParam = searchParams.get('tab');
    // if (tabParam === 'buying') {
    //   this.setState({ activeFilter: 'buying' });
    // }
  }

  _unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, this._savedScrollY || 0);
    this._scrollLocked = false;
  }

  componentDidUpdate() {
    var shouldLock = !!(this.state.followModal || this.state.editModalPost);
    if (shouldLock && !this._scrollLocked) {
      this._savedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + this._savedScrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      this._scrollLocked = true;
    } else if (!shouldLock && this._scrollLocked) {
      this._unlockScroll();
    }
  }

  componentWillUnmount() {
    if (this._scrollLocked) {
      this._unlockScroll();
    }
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('authStateChanged', this.handleAuthStateChanged);
    if (this._handleThemeChanged) {
      window.removeEventListener('themeChanged', this._handleThemeChanged);
    }
  }

  handleScroll() {
    var show = window.scrollY > 400;
    if (show !== this.state.showBackToTop) {
      this.setState({ showBackToTop: show });
    }
  }

  componentWillReceiveProps(nextProps) {
    var pastMatch = matchPath(this.props.location.pathname, {
      path: '/shop/:username',
      exact: false,
      strict: false,
    });
    var currentMatch = matchPath(nextProps.location.pathname, {
      path: '/shop/:username',
      exact: false,
      strict: false,
    });
    if (currentMatch && pastMatch && currentMatch.params.username !== pastMatch.params.username) {
      this.setState({ activeFilter: 'active', showItems: 20, showReviews: false, showAllReviews: false, reviewSort: 'newest', searchQuery: '', sortBy: 'newest', categoryFilter: 'all', foilFilter: false });
      this.profile(currentMatch.params.username);
    }
  }

  handleShowMore() {
    this.setState({
      showItems: this.state.showItems >= this.state.posts.length
        ? this.state.showItems
        : this.state.showItems + 20,
    });
  }

  profile(username) {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/guest/meta/' + username, {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      self.setState({
        id: res.profile._id,
        posts: res.sortedProfile,
        name: res.profile.name,
        username: res.profile.userName,
        bio: res.profile.bio,
        profilePic: res.profile.image && res.profile.image.indexOf('http') === 0 ? res.profile.image : constants.DOMAIN + '/' + res.profile.image,
        backgroundPicture: constants.DOMAIN + '/' + res.profile.backgroundPicture,
        following: res.profile.isFollowing,
        followers: res.profile.followers,
        rating: res.profile.rating,
        reviews: res.reviews,
        createdAt: res.profile.createdAt,
        instagram: res.profile.instagram || '',
        twitter: res.profile.twitter || '',
        preferredShipping: res.profile.preferredShipping || '',
        preferredPayment: res.profile.preferredPayment || '',
        locationCity: (res.profile.location && res.profile.location.city) || '',
        locationState: (res.profile.location && res.profile.location.state) || '',
        shopActive: res.profile.shopActive !== false,
        verified: res.profile.verified || false,
        loading: false,
      }, function() {
        // BUYLIST FEATURE: disabled — preserved for future use
        // Auth.fetch(constants.DOMAIN + '/api/v1/buylist/user/' + res.profile._id, {
        //   method: 'GET',
        // }).then(function(buylistRes) {
        //   self.setState({ buylistCount: (buylistRes.entries || []).length });
        // }).catch(function() {});

        if (Auth.getToken()) {
          Auth.fetch(constants.DOMAIN + '/api/v1/users/' + self.state.id, {
            mode: 'cors',
            method: 'GET',
          }).then(function(response) {
            var user = Auth.getProfile();
            self.setState({
              posts: response.sortedProfile,
              isFollowing: response.profile.following,
              isSelf: self.state.id === user._id,
            });
          }).catch(function(err) { console.log(err); });
        }
      });
    }).catch(function(err) {
      console.log(err);
      self.setState({ loading: false });
    });
  }

  handleFollow() {
    var self = this;
    if (Auth.getToken()) {
      if (this.state.isFollowing === false) {
        Auth.fetch(constants.DOMAIN + '/api/v1/users/' + this.state.id + '/follow', {
          mode: 'cors',
          method: 'POST',
        }).then(function(res) {
          self.setState({
            isFollowing: res.profile.following,
            followers: res.profile.followers,
          });
        }).catch(function(err) { console.log(err); });
      } else {
        Auth.fetch(constants.DOMAIN + '/api/v1/users/' + this.state.id + '/unfollow', {
          mode: 'cors',
          method: 'DELETE',
        }).then(function(res) {
          self.setState({
            isFollowing: res.profile.following,
            followers: res.profile.followers,
          });
        }).catch(function(err) { console.log(err); });
      }
    } else {
      this.context.openAuthModal('login');
    }
  }

  openFollowModal(type) {
    var self = this;
    this.setState({ followModal: type, followModalData: [], followModalLoading: true });
    var endpoint = type === 'followers'
      ? '/api/v1/guest/followers/' + this.state.id
      : '/api/v1/guest/following/' + this.state.id;
    Auth.fetch(constants.DOMAIN + endpoint, { mode: 'cors', method: 'GET' })
      .then(function(res) {
        var list = type === 'followers' ? res.followerList : res.followingList;
        self.setState({ followModalData: list || [], followModalLoading: false });
      })
      .catch(function() {
        self.setState({ followModalLoading: false });
      });
  }

  handleFilterChange(filter) {
    this.setState({ activeFilter: filter });
  }

  toggleReviews() {
    this.setState({ showReviews: !this.state.showReviews });
  }

  toggleShopActive() {
    var self = this;
    var newValue = !this.state.shopActive;
    this.setState({ togglingShop: true });
    var body = new URLSearchParams();
    body.append('shopActive', newValue);
    Auth.fetch(constants.DOMAIN + '/api/v1/users/profile', {
      mode: 'cors',
      method: 'PATCH',
      body: body,
    }).then(function() {
      self.setState({ shopActive: newValue, togglingShop: false });
    }).catch(function(err) {
      console.log(err);
      self.setState({ togglingShop: false });
    });
  }

  openEditModal(postId) {
    var self = this;
    this.setState({
      editModalPost: postId,
      editModalLoading: true,
      editModalSaving: false,
      editModalDeleting: false,
      editModal: {},
      editModalPhotos: [],
      editModalExistingPhotos: [],
      editModalPhotoError: '',
      editModalProcessingPhoto: false,
      editModalErrors: {},
      editModalCard: null,
      editModalCardImage: null,
      editModalShowDesc: false,
      editModalShowPhotos: false,
    });

    Auth.fetch(constants.DOMAIN + '/api/v1/posts/' + postId, {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      if (self.state.editModalPost !== postId) return; // stale guard
      var catParts = (res.category || '').split(' ');
      var mainCategory = catParts[0] || 'singles';
      var conditionFromCat = catParts[1] || null;

      self.setState({
        editModalLoading: false,
        editModalShowDesc: !!(res.text && res.text.trim()),
        editModalShowPhotos: !!(res.images && res.images.length > 0),
        editModal: {
          title: res.title || '',
          description: res.text || '',
          price: res.price != null ? String(res.price) : '',
          quantity: res.quantity != null ? String(res.quantity) : '1',
          condition: res.condition || conditionFromCat || 'NM',
          category: mainCategory,
          allowSharing: res.allowSharing !== false,
          shareCommission: (res.shareCommissionType === 'percentage' || !res.shareCommissionType)
            ? Math.max(1, Math.floor(Number(res.price || 0) * ((res.shareCommission || 5) / 100) * 100) / 100)
            : Math.max(1, Number(res.shareCommission) || 1),
          acceptOffers: res.acceptOffers === true,
          connectedCards: (res.cards && res.cards.length > 0) ? res.cards.slice() : [],
          cardImage: res.cardImage || null,
          shippingCost: res.shippingCost != null ? Number(res.shippingCost) : 0,
        },
      });

      // Load existing photos
      if (res.images && res.images.length > 0) {
        var existingPhotos = res.images.map(function(img) {
          return { url: constants.TMP_API + img, path: img };
        });
        self.setState({ editModalExistingPhotos: existingPhotos });

        var photoPromises = res.images.map(function(img) {
          return fetch(constants.TMP_API + img, { mode: 'cors', method: 'GET' })
            .then(function(r) { return r.blob(); })
            .then(function(blob) {
              var fileName = img.split('/').pop() || 'image.jpg';
              var file = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });
              return { file: file, preview: constants.TMP_API + img };
            })
            .catch(function() { return null; });
        });

        Promise.all(photoPromises).then(function(photos) {
          if (self.state.editModalPost !== postId) return; // stale guard
          self.setState({ editModalPhotos: photos.filter(Boolean) });
        });
      }

      // Load card data
      if (res.cards && res.cards.length > 0) {
        fetch(constants.DOMAIN + '/api/v1/guest/card/' + res.cards[0], { mode: 'cors', method: 'GET' })
          .then(function(r) { return r.json(); })
          .then(function(cardData) {
            if (self.state.editModalPost !== postId) return; // stale guard
            if (cardData) {
              var cardImg = resolveCardImage(cardData.image);
              self.setState({
                editModalCard: cardData,
                editModalCardImage: res.cardImage || cardImg,
              });
            }
          })
          .catch(function() {});
      }
    }).catch(function(err) {
      console.error(err);
      self.setState({ editModalLoading: false, editModalErrors: { _global: 'Failed to load listing. Please try again.' } });
    });
  }

  closeEditModal() {
    this.setState({
      editModalPost: null,
      editModalLoading: false,
      editModal: {},
      editModalPhotos: [],
      editModalExistingPhotos: [],
      editModalErrors: {},
      editModalCard: null,
      editModalCardImage: null,
    });
  }

  handleEditSubmit() {
    var form = this.state.editModal;
    var errors = {};
    if (!form.title || !form.title.trim()) errors.title = 'Title is required';
    if (!form.price || isNaN(Number(form.price)) || Number(form.price) < 0.75) {
      errors.price = 'Minimum price is $0.75';
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ editModalErrors: errors });
      return;
    }

    this.setState({ editModalSaving: true, editModalErrors: {} });

    var data = new FormData();
    data.append('title', form.title);
    data.append('text', form.description || '');
    data.append('price', Number(form.price));
    var isSealed = form.category === 'sealed';
    data.append('category', isSealed ? form.category : form.category + ' ' + form.condition);
    data.append('shippingCost', form.shippingCost != null ? form.shippingCost : 0);
    data.append('condition', form.condition);
    data.append('quantity', Number(form.quantity) || 1);
    data.append('allowSharing', form.allowSharing);
    data.append('shareCommission', Math.max(1, Number(form.shareCommission) || 1));
    data.append('shareCommissionType', 'amount');
    data.append('acceptOffers', form.acceptOffers);
    data.append('foil', form.condition ? form.condition.endsWith('F') : false);

    if (form.connectedCards && form.connectedCards.length > 0) {
      data.append('cards', form.connectedCards.join(','));
    } else {
      data.append('cards', '');
    }
    if (form.cardImage) {
      data.append('cardImage', form.cardImage);
    }

    this.state.editModalPhotos.forEach(function(p) {
      if (p && p.file) {
        data.append('images', p.file, p.file.name);
      }
    });

    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/posts/' + this.state.editModalPost, {
      mode: 'cors',
      method: 'PATCH',
      body: data,
    }).then(function() {
      self.closeEditModal();
      // Re-fetch profile to get updated listing data
      var match = matchPath(self.props.location.pathname, {
        path: '/shop/:username',
        exact: false,
        strict: false,
      });
      if (match) {
        self.profile(match.params.username);
      }
    }).catch(function(err) {
      console.error(err);
      self.setState({ editModalSaving: false, editModalErrors: { _global: 'Failed to save changes. Please try again.' } });
    });
  }

  handleEditDelete() {
    if (!window.confirm('Are you sure you want to delete this listing? This cannot be undone.')) {
      return;
    }
    this.setState({ editModalDeleting: true });
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/posts/' + this.state.editModalPost, {
      mode: 'cors',
      method: 'DELETE',
    }).then(function() {
      self.closeEditModal();
      var match = matchPath(self.props.location.pathname, {
        path: '/shop/:username',
        exact: false,
        strict: false,
      });
      if (match) {
        self.profile(match.params.username);
      }
    }).catch(function(err) {
      console.error(err);
      self.setState({ editModalDeleting: false, editModalErrors: { _global: 'Failed to delete listing. Please try again.' } });
    });
  }

  editModalAddPhoto(event) {
    var inputEl = event.target;
    var file = inputEl.files[0];
    if (!file || this.state.editModalPhotos.length >= 4) return;

    if (ACCEPTED_TYPES.indexOf(file.type) === -1) {
      this.setState({ editModalPhotoError: 'Unsupported format. Use JPG, PNG, GIF, or WebP.' });
      inputEl.value = '';
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      this.setState({ editModalPhotoError: 'File too large. Max 10 MB.' });
      inputEl.value = '';
      return;
    }

    this.setState({ editModalPhotoError: '', editModalProcessingPhoto: true });
    var self = this;

    var reader = new FileReader();
    reader.onload = function() {
      var img = new Image();
      img.onload = function() {
        var targetWidth = img.width;
        if (targetWidth > (constants.MAX_IMAGE_WIDTH || 1200)) targetWidth = constants.MAX_IMAGE_WIDTH || 1200;
        else if (targetWidth >= (constants.MIN_IMAGE_WIDTH || 400)) targetWidth = Math.round(targetWidth * 0.8);

        new Compressor(file, {
          quality: constants.IMAGE_COMPRESSION || 0.8,
          maxWidth: targetWidth,
          success: function(result) {
            var finalFile = result instanceof File
              ? result
              : new File([result], result.name, { type: result.type, lastModified: Date.now() });

            var fr = new FileReader();
            fr.onload = function(e) {
              self.setState(function(prev) {
                return {
                  editModalPhotos: prev.editModalPhotos.concat([{ file: finalFile, preview: e.target.result }]),
                  editModalProcessingPhoto: false,
                };
              });
            };
            fr.readAsDataURL(finalFile);
          },
          error: function() {
            self.setState({ editModalPhotoError: 'Could not process image.', editModalProcessingPhoto: false });
          },
        });
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
    inputEl.value = '';
  }

  editModalRemovePhoto(index) {
    this.setState(function(prev) {
      return { editModalPhotos: prev.editModalPhotos.filter(function(_, i) { return i !== index; }) };
    });
  }

  renderEditModal() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var form = this.state.editModal;
    var card = this.state.editModalCard;
    var cardImage = this.state.editModalCardImage;
    var photos = this.state.editModalPhotos;
    var errors = this.state.editModalErrors;
    var cardRarity = card ? card.rarity : null;
    var isSealed = form.category === 'sealed';
    var conditionsList = buildConditionsList(null, LEGACY_NO_FOIL_RARITIES, cardRarity);
    if (isSealed) {
      conditionsList = conditionsList.filter(function(c) { return !c.foilOnly; });
    }

    var inputStyle = {
      width: '100%',
      padding: '10px 12px',
      fontSize: '14px',
      borderRadius: '8px',
      border: isDark ? '1px solid #555' : '1px solid #e0e0e0',
      outline: 'none',
      backgroundColor: isDark ? '#141414' : '#fff',
      color: isDark ? '#fff' : '#1a1a1a',
    };

    var priceTooLow = !form.price || Number(form.price) < SHARE_MIN_PRICE;
    var sharingEnabled = form.allowSharing && !priceTooLow;

    return (
      <div className="tw-fixed tw-inset-0 tw-z-[9999] tw-flex tw-items-start tw-justify-center tw-pt-8 tw-pb-8" onClick={function() { self.closeEditModal(); }}>
        <div className="tw-absolute tw-inset-0 tw-bg-black/50" style={{ backdropFilter: 'blur(4px)' }} />
        <div
          className="modal-enter tw-relative tw-rounded-xl tw-w-full tw-max-w-lg tw-mx-4 tw-max-h-[calc(100vh-4rem)] tw-overflow-y-auto"
          style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.3)', backgroundColor: isDark ? '#1a1a1a' : '#fff' }}
          onClick={function(e) { e.stopPropagation(); }}
        >
          {/* Header */}
          <div className="tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-4 tw-sticky tw-top-0 tw-z-10" style={{ borderBottom: isDark ? '1px solid #333' : '1px solid #eee', backgroundColor: isDark ? '#1a1a1a' : '#fff' }}>
            <h3 className="tw-text-lg tw-font-bold tw-m-0" style={{ color: isDark ? '#fff' : '#111' }}>Edit Listing</h3>
            <button onClick={function() { self.closeEditModal(); }} className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xl tw-p-1" style={{ color: '#888' }}>
              <i className="fa fa-times" />
            </button>
          </div>

          {this.state.editModalLoading ? (
            <div className="tw-text-center tw-py-16">
              <i className="fa fa-spinner fa-spin tw-text-2xl tw-text-brand-gold" />
            </div>
          ) : (
            <div className="tw-px-5 tw-py-4">
              {/* Connected Card (read-only) */}
              {card && (
                <div className="tw-mb-4">
                  <div className="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-xl" style={{ backgroundColor: isDark ? '#141414' : '#f9fafb', border: isDark ? '1px solid #333' : '1px solid #eee' }}>
                    {cardImage && (
                      <img src={cardImage} alt={card.name} className="tw-w-12 tw-rounded" style={{ aspectRatio: '63/88', objectFit: 'contain' }} />
                    )}
                    <div className="tw-flex-1 tw-min-w-0">
                      <p className="tw-text-sm tw-font-bold tw-mb-0 tw-truncate" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>
                        {card.name}{card.variant ? ' (' + card.variant + ')' : ''}
                      </p>
                      <p className="tw-text-xs tw-mb-0" style={{ color: isDark ? '#666' : '#999' }}>
                        {card.cardSet}{card.rarity ? ' \u2022 ' + card.rarity : ''}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Price + Quantity */}
              <div className="tw-flex tw-gap-3 tw-mb-4">
                <div className="tw-flex-1">
                  <label className="tw-block tw-text-sm tw-font-semibold tw-mb-1.5" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>Price</label>
                  <div className="tw-relative">
                    <span className="tw-absolute tw-left-3 tw-top-1/2 tw-text-sm tw-text-[#999] tw-font-medium" style={{ transform: 'translateY(-50%)' }}>$</span>
                    <input
                      type="text"
                      value={form.price}
                      onChange={function(e) {
                        var re = /^(?!\.?$)\d{0,4}(\.\d{0,2})?$/;
                        if (e.target.value === '' || re.test(e.target.value)) {
                          self.setState({ editModal: Object.assign({}, form, { price: e.target.value }) });
                        }
                      }}
                      onBlur={function() {
                        if (form.price) {
                          self.setState({ editModal: Object.assign({}, form, { price: Number(form.price).toFixed(2) }) });
                        }
                      }}
                      placeholder="0.00"
                      style={Object.assign({}, inputStyle, { paddingLeft: '24px' })}
                      className="focus:tw-border-brand-gold"
                    />
                  </div>
                  {errors.price && <p className="tw-text-red-500 tw-text-xs tw-mt-1 tw-mb-0">{errors.price}</p>}
                </div>
                <div style={{ width: '80px' }}>
                  <label className="tw-block tw-text-sm tw-font-semibold tw-mb-1.5" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>Qty</label>
                  <input
                    type="number"
                    min="1"
                    value={form.quantity}
                    onChange={function(e) {
                      var val = e.target.value;
                      if (val === '' || (Number(val) >= 1 && Number(val) <= 999)) {
                        self.setState({ editModal: Object.assign({}, form, { quantity: val }) });
                      }
                    }}
                    style={inputStyle}
                    className="focus:tw-border-brand-gold"
                  />
                </div>
              </div>

              {/* Condition (hidden for sealed products) */}
              {!isSealed && (
              <div className="tw-mb-4">
                <label className="tw-block tw-text-sm tw-font-semibold tw-mb-1.5" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>Condition/Foil</label>
                <select
                  value={form.condition}
                  onChange={function(e) { self.setState({ editModal: Object.assign({}, form, { condition: e.target.value }) }); }}
                  style={Object.assign({}, inputStyle, { fontSize: '16px' })}
                  className="focus:tw-border-brand-gold"
                >
                  {(function() {
                    var nonFoil = conditionsList.filter(function(c) { return !c.foilOnly; });
                    var foil = conditionsList.filter(function(c) { return c.foilOnly; });
                    if (foil.length > 0) {
                      return [
                        <optgroup key="nf" label="Non-Foil">
                          {nonFoil.map(function(c) { return <option key={c.value} value={c.value}>{c.label}</option>; })}
                        </optgroup>,
                        <optgroup key="f" label="Foil">
                          {foil.map(function(c) { return <option key={c.value} value={c.value}>{c.label}</option>; })}
                        </optgroup>
                      ];
                    }
                    return nonFoil.map(function(c) { return <option key={c.value} value={c.value}>{c.label}</option>; });
                  })()}
                </select>
              </div>
              )}

              {/* Title */}
              <div className="tw-mb-4">
                <label className="tw-block tw-text-sm tw-font-semibold tw-mb-1.5" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>Title</label>
                <input
                  type="text"
                  value={form.title}
                  onChange={function(e) { self.setState({ editModal: Object.assign({}, form, { title: e.target.value }) }); }}
                  style={inputStyle}
                  className="focus:tw-border-brand-gold"
                />
                {errors.title && <p className="tw-text-red-500 tw-text-xs tw-mt-1 tw-mb-0">{errors.title}</p>}
              </div>

              {/* Description (collapsible) */}
              <div className="tw-mb-4">
                <button
                  type="button"
                  onClick={function() { self.setState({ editModalShowDesc: !self.state.editModalShowDesc }); }}
                  className="tw-flex tw-items-center tw-justify-between tw-w-full tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-0 tw-mb-1.5"
                >
                  <span className="tw-text-sm tw-font-semibold" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>
                    Description <span className="tw-font-normal tw-text-[#999] tw-ml-1">(optional)</span>
                    {!self.state.editModalShowDesc && form.description ? (
                      <span className="tw-text-xs tw-font-normal tw-ml-2" style={{ color: '#c9a84c' }}>
                        <i className="fa fa-check tw-mr-0.5" />has content
                      </span>
                    ) : null}
                  </span>
                  <i className={'fa tw-text-xs tw-text-[#999] ' + (self.state.editModalShowDesc ? 'fa-chevron-up' : 'fa-chevron-down')} />
                </button>
                {self.state.editModalShowDesc && (
                  <textarea
                    value={form.description}
                    onChange={function(e) { self.setState({ editModal: Object.assign({}, form, { description: e.target.value }) }); }}
                    rows={3}
                    style={Object.assign({}, inputStyle, { resize: 'none' })}
                    className="focus:tw-border-brand-gold"
                  />
                )}
              </div>

              {/* Share & Earn Toggle */}
              <div className="tw-mb-4">
                <div className="tw-flex tw-items-center tw-justify-between tw-mb-1">
                  <label className="tw-block tw-text-sm tw-font-semibold tw-mb-0" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>Share & Earn</label>
                  <button
                    type="button"
                    onClick={function() { if (!priceTooLow) { self.setState({ editModal: Object.assign({}, form, { allowSharing: !form.allowSharing }) }); } }}
                    className="tw-relative tw-w-10 tw-h-5 tw-rounded-full tw-border-none tw-transition-colors tw-flex-shrink-0"
                    style={{ backgroundColor: sharingEnabled ? '#c9a84c' : '#ccc', cursor: priceTooLow ? 'not-allowed' : 'pointer', opacity: priceTooLow ? 0.5 : 1 }}
                  >
                    <span className="tw-absolute tw-top-0.5 tw-w-4 tw-h-4 tw-rounded-full tw-bg-white tw-transition-all tw-shadow-sm" style={{ left: sharingEnabled ? '22px' : '2px' }} />
                  </button>
                </div>
                {priceTooLow ? (
                  <p className="tw-text-xs tw-mt-0 tw-mb-0" style={{ color: '#c9a84c' }}>Available for items $10.00+</p>
                ) : (
                  <p className="tw-text-xs tw-text-[#888] tw-mt-0 tw-mb-0">Let others promote your listing</p>
                )}
                {sharingEnabled && (
                  <div className="tw-mt-2">
                    <label className="tw-block tw-text-xs tw-font-medium tw-mb-1" style={{ color: isDark ? '#aaa' : '#555' }}>Commission Amount</label>
                    <div className="tw-relative">
                      <span className="tw-absolute tw-left-3 tw-top-1/2 tw-text-sm tw-text-[#999] tw-font-medium" style={{ transform: 'translateY(-50%)' }}>$</span>
                      <input
                        type="text"
                        value={form.shareCommission}
                        onChange={function(e) {
                          var val = e.target.value;
                          var re = /^(?!\.?$)\d{0,4}(\.\d{0,2})?$/;
                          if (val === '' || re.test(val)) {
                            var maxComm = Math.floor(Number(form.price || 0) * 0.90 * 100) / 100;
                            var numVal = Number(val);
                            if (val !== '' && numVal > maxComm) { val = String(maxComm); numVal = maxComm; }
                            self.setState({ editModal: Object.assign({}, form, { shareCommission: val === '' ? '' : numVal || val }) });
                          }
                        }}
                        onBlur={function() {
                          var num = Number(form.shareCommission);
                          if (!num || num < 1) { self.setState({ editModal: Object.assign({}, form, { shareCommission: 1 }) }); }
                        }}
                        placeholder="1.00"
                        style={Object.assign({}, inputStyle, { paddingLeft: '24px' })}
                        className="focus:tw-border-brand-gold"
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Open to Offers Toggle */}
              <div className="tw-mb-4">
                <div className="tw-flex tw-items-center tw-justify-between tw-mb-1">
                  <label className="tw-block tw-text-sm tw-font-semibold tw-mb-0" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>Open to Offers</label>
                  <button
                    type="button"
                    onClick={function() { self.setState({ editModal: Object.assign({}, form, { acceptOffers: !form.acceptOffers }) }); }}
                    className="tw-relative tw-w-10 tw-h-5 tw-rounded-full tw-border-none tw-cursor-pointer tw-transition-colors tw-flex-shrink-0"
                    style={{ backgroundColor: form.acceptOffers ? '#c9a84c' : '#ccc' }}
                  >
                    <span className="tw-absolute tw-top-0.5 tw-w-4 tw-h-4 tw-rounded-full tw-bg-white tw-transition-all tw-shadow-sm" style={{ left: form.acceptOffers ? '22px' : '2px' }} />
                  </button>
                </div>
                <p className="tw-text-xs tw-text-[#888] tw-mt-0 tw-mb-0">Allow buyers to make offers below your listed price</p>
              </div>

              {/* Condition Photos (collapsible) */}
              <div className="tw-mb-4">
                <button
                  type="button"
                  onClick={function() { self.setState({ editModalShowPhotos: !self.state.editModalShowPhotos }); }}
                  className="tw-flex tw-items-center tw-justify-between tw-w-full tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-0 tw-mb-1"
                >
                  <span className="tw-text-sm tw-font-semibold" style={{ color: isDark ? '#fff' : '#1a1a1a' }}>
                    Condition Photos <span className="tw-font-normal tw-text-[#999] tw-ml-1">(optional)</span>
                    {!self.state.editModalShowPhotos && photos.length > 0 ? (
                      <span className="tw-text-xs tw-font-normal tw-ml-2" style={{ color: '#c9a84c' }}>
                        <i className="fa fa-image tw-mr-0.5" />{photos.length} photo{photos.length !== 1 ? 's' : ''}
                      </span>
                    ) : null}
                  </span>
                  <i className={'fa tw-text-xs tw-text-[#999] ' + (self.state.editModalShowPhotos ? 'fa-chevron-up' : 'fa-chevron-down')} />
                </button>
                {self.state.editModalShowPhotos && (
                  <div>
                    {this.state.editModalPhotoError && (
                      <p className="tw-text-red-500 tw-text-xs tw-mb-2 tw-mt-0">{this.state.editModalPhotoError}</p>
                    )}
                    <div className="tw-grid tw-grid-cols-4 tw-gap-2">
                      {photos.map(function(photo, i) {
                        return (
                          <div key={i} className="tw-relative tw-aspect-square tw-rounded-lg tw-overflow-hidden tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#141414' : '#f3f4f6', border: isDark ? '1px solid #333' : '1px solid #e0e0e0' }}>
                            <img src={photo.preview} alt={'Photo ' + (i + 1)} className="tw-max-w-full tw-max-h-full tw-object-contain" />
                            <button
                              type="button"
                              onClick={function() { self.editModalRemovePhoto(i); }}
                              className="tw-absolute tw-top-1 tw-right-1 tw-w-5 tw-h-5 tw-rounded-full tw-bg-red-600 tw-text-white tw-text-[10px] tw-font-bold tw-border-none tw-cursor-pointer tw-flex tw-items-center tw-justify-center"
                            >
                              &times;
                            </button>
                          </div>
                        );
                      })}
                      {this.state.editModalProcessingPhoto && (
                        <div className="tw-aspect-square tw-rounded-lg tw-overflow-hidden tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#141414' : '#f3f4f6', border: isDark ? '1px solid #333' : '1px solid #e0e0e0' }}>
                          <div className="tw-w-6 tw-h-6 tw-rounded-full tw-border-2 tw-border-[#e0e0e0]" style={{ borderTopColor: '#c9a84c', animation: 'spin 0.8s linear infinite' }} />
                        </div>
                      )}
                      {!this.state.editModalProcessingPhoto && photos.length < 4 && (
                        <label className="tw-aspect-square tw-rounded-lg tw-border-2 tw-border-dashed tw-flex tw-flex-col tw-items-center tw-justify-center tw-cursor-pointer hover:tw-border-brand-gold tw-transition-colors" style={{ borderColor: isDark ? '#444' : '#d0d0d0', backgroundColor: isDark ? '#0f0f0f' : '#f9fafb' }}>
                          <i className="fa fa-camera tw-text-lg tw-text-[#bbb]" />
                          <span className="tw-text-[10px] tw-text-[#999] tw-font-medium tw-mt-0.5">Add</span>
                          <input
                            type="file"
                            accept=".jpg,.jpeg,.png,.gif,.webp"
                            onChange={function(e) { self.editModalAddPhoto(e); }}
                            style={{ display: 'none' }}
                          />
                        </label>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Global Error */}
              {errors._global && (
                <p className="tw-text-red-500 tw-text-sm tw-text-center tw-mb-2 tw-mt-0">{errors._global}</p>
              )}

              {/* Action Buttons */}
              <button
                type="button"
                onClick={this.handleEditSubmit}
                disabled={this.state.editModalSaving || this.state.editModalDeleting}
                className="tw-w-full tw-font-bold tw-py-3 tw-rounded-lg tw-text-sm tw-cursor-pointer tw-border-none disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                style={{ backgroundColor: '#c9a84c', color: '#000', transition: 'all 0.15s ease' }}
              >
                {this.state.editModalSaving ? 'Saving...' : 'Save Changes'}
              </button>
              <button
                type="button"
                onClick={this.handleEditDelete}
                disabled={this.state.editModalSaving || this.state.editModalDeleting}
                className="tw-w-full tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-medium tw-cursor-pointer tw-border-none tw-transition-colors tw-mt-2 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                style={{ backgroundColor: 'transparent', color: '#ef4444' }}
              >
                {this.state.editModalDeleting ? 'Deleting...' : 'Delete Listing'}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderListingCard(post) {
    var isDark = document.documentElement.classList.contains('tw-dark');
    var api = constants.DOMAIN + '/';
    // Prefer card catalog image (always available), fall back to uploaded image
    var image;
    if (post.cardImage) {
      image = resolveCardImage(post.cardImage);
    } else if (post.images && post.images.length > 0) {
      image = api + post.images[0];
    } else {
      image = whitebox;
    }
    var isSelf = this.state.isSelf && Auth.getToken();
    var isHoriz = post.cardHorizontal === true;
    var self = this;
    var hoverKey = '_cardHover_' + post._id;
    var isHovered = !!this[hoverKey];
    var canHover = this.state.shopActive || isSelf;

    return (
      <div key={post._id} className={'tw-group tw-rounded-xl tw-overflow-hidden' + (isHoriz ? ' horiz-card' : '')}
        style={{
          backgroundColor: isDark ? '#1a1a1a' : '#fff',
          border: isHovered && canHover ? '1px solid #c9a84c' : (isDark ? '1px solid #2a2a2a' : '1px solid #eee'),
          boxShadow: isHovered && canHover ? '0 4px 16px rgba(201,168,76,0.12)' : '0 1px 3px rgba(0,0,0,0.04)',
          transform: isHovered && canHover ? 'translateY(-2px)' : 'translateY(0)',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={canHover ? function() { self[hoverKey] = true; self.forceUpdate(); } : undefined}
        onMouseLeave={canHover ? function() { self[hoverKey] = false; self.forceUpdate(); } : undefined}
      >
        <Link to={'/product/' + post._id} className="tw-block tw-no-underline" onClick={!this.state.shopActive && !isSelf ? function(e) { e.preventDefault(); } : undefined} style={!this.state.shopActive && !isSelf ? { pointerEvents: 'none' } : {}}>
          <div className={'tw-relative tw-flex tw-items-center tw-justify-center' + (isHoriz ? ' horiz-card-img-tall' : '')} style={Object.assign({ backgroundColor: isDark ? '#0f0f0f' : '#f5f5f5' }, isHoriz ? {} : { aspectRatio: '4/5' })}>
            <LazyCardImage
              src={image}
              alt={post.title}
              fallbackSize="tw-w-16 tw-h-16"
              rotate={isHoriz ? (post.cardRotation || -90) : 0}
            />
            {post.sold ? (
              <div className="tw-absolute tw-inset-0 tw-bg-black/60 tw-flex tw-items-center tw-justify-center">
                <span className="tw-text-white tw-text-lg tw-font-bold tw-tracking-wider">SOLD</span>
              </div>
            ) : null}
            {!post.sold && post.price >= (constants.FREE_SHIPPING_THRESHOLD || 10) ? (
              <div className="tw-absolute tw-top-2 tw-right-2 tw-bg-green-600/90 tw-text-white tw-text-[10px] tw-font-semibold tw-px-2.5 tw-py-1 tw-rounded-full">
                Free Shipping
              </div>
            ) : null}
            {!post.sold && post.foil ? (
              <div
                className="tw-absolute tw-top-2 tw-left-2 tw-text-[10px] tw-font-bold tw-px-2.5 tw-py-1 tw-rounded-full tw-text-black"
                style={{ background: 'linear-gradient(135deg, #ffd700, #ffaa00, #ffd700)' }}
              >
                FOIL
              </div>
            ) : null}
            {!post.sold ? (
              <div className="tw-absolute tw-bottom-2 tw-left-2 tw-flex tw-items-center tw-bg-black/75 tw-rounded-full tw-overflow-hidden">
                <span className="tw-text-brand-gold tw-text-sm tw-font-bold tw-px-3 tw-py-1">
                  ${(post.price || 0).toFixed(2)}
                </span>
                {post.price < (constants.FREE_SHIPPING_THRESHOLD || 10) ? (
                  <span className="tw-text-[#aaa] tw-text-[10px] tw-font-semibold tw-pr-3 tw-py-1">+ $1 Ship</span>
                ) : null}
              </div>
            ) : null}
            {!post.sold && (post.quantity || 1) > 1 ? (
              <div className="tw-absolute tw-bottom-2 tw-right-2 tw-bg-black/75 tw-text-white tw-text-sm tw-font-bold tw-px-3 tw-py-1 tw-rounded-full">
                x{post.quantity}
              </div>
            ) : null}
          </div>
          <div className="tw-px-3 tw-py-2.5">
            <p className="tw-text-[13px] tw-font-medium tw-truncate tw-leading-tight" style={{ color: isDark ? '#fff' : '#111' }}>{(post.title || '').replace(/\s*\(Foil\)/i, '')}</p>
            <div className="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-gap-x-1 tw-gap-y-0.5 tw-mt-1.5">
              {post.category ? (
                <span className="tw-text-[10px]" style={{ color: isDark ? '#666' : '#999' }}>
                  {(function() {
                    var raw = post.category.replace(/^singles\s*/i, '');
                    var isFoil = raw.endsWith('F');
                    var label = isFoil ? raw.replace(/F$/, '') : raw;
                    return (conditionMap[label] || label) + (isFoil ? ' Foil' : '');
                  })()}
                </span>
              ) : <span />}
              {renderRarityBadge(post.cardRarity, null)}
            </div>
          </div>
        </Link>
        {isSelf && !post.sold ? (
          <div className="tw-flex tw-gap-2 tw-px-3 tw-pb-3">
            <button
              onClick={function() { self.openEditModal(post._id); }}
              className="tw-text-xs tw-text-brand-gold hover:tw-underline tw-no-underline tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-0"
            >
              <i className="fa fa-pencil tw-mr-1"></i>Edit
            </button>
          </div>
        ) : null}
      </div>
    );
  }

  renderListRow(post) {
    var isDark = document.documentElement.classList.contains('tw-dark');
    var api = constants.DOMAIN + '/';
    var image;
    if (post.cardImage) {
      image = resolveCardImage(post.cardImage);
    } else if (post.images && post.images.length > 0) {
      image = api + post.images[0];
    } else {
      image = whitebox;
    }
    var isSelf = this.state.isSelf && Auth.getToken();
    var self = this;
    var canClick = this.state.shopActive || isSelf;

    return (
      <div key={post._id} className="tw-flex tw-items-center tw-gap-3 tw-py-3 tw-px-3 tw-rounded-lg tw-transition-colors"
        style={{ borderBottom: isDark ? '1px solid #2a2a2a' : '1px solid #f0f0f0' }}
        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#1f1f1f' : '#f9f9f9'; }}
        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
      >
        {/* Thumbnail */}
        <Link to={'/product/' + post._id} className="tw-flex-shrink-0 tw-no-underline" onClick={!canClick ? function(e) { e.preventDefault(); } : undefined} style={!canClick ? { pointerEvents: 'none' } : {}}>
          <div className="tw-w-12 tw-h-12 tw-rounded-lg tw-overflow-hidden tw-flex tw-items-center tw-justify-center tw-relative" style={{ backgroundColor: isDark ? '#0f0f0f' : '#f5f5f5' }}>
            <img src={image} alt={post.title} className="tw-max-w-full tw-max-h-full tw-object-contain" />
            {post.sold ? (
              <div className="tw-absolute tw-inset-0 tw-bg-black/60 tw-flex tw-items-center tw-justify-center">
                <span className="tw-text-white tw-text-[8px] tw-font-bold">SOLD</span>
              </div>
            ) : null}
          </div>
        </Link>

        {/* Title & Details */}
        <Link to={'/product/' + post._id} className="tw-flex-1 tw-min-w-0 tw-no-underline" onClick={!canClick ? function(e) { e.preventDefault(); } : undefined} style={!canClick ? { pointerEvents: 'none' } : {}}>
          <p className="tw-text-sm tw-font-medium tw-truncate tw-mb-0" style={{ color: isDark ? '#fff' : '#111' }}>
            {(post.title || '').replace(/\s*\(Foil\)/i, '')}
          </p>
          <div className="tw-flex tw-items-center tw-gap-2 tw-mt-0.5">
            {post.category ? (
              <span className="tw-text-[11px]" style={{ color: isDark ? '#666' : '#999' }}>
                {formatCondition(getCondition(post.category))}
              </span>
            ) : null}
            {post.foil ? (
              <span className="tw-text-[10px] tw-font-bold tw-px-1.5 tw-py-0.5 tw-rounded-full" style={{ background: 'linear-gradient(135deg, #ffd700, #ffaa00)', color: '#000' }}>FOIL</span>
            ) : null}
            {renderRarityBadge(post.cardRarity, null)}
          </div>
        </Link>

        {/* Quantity */}
        {!post.sold && (post.quantity || 1) > 1 ? (
          <span className="tw-text-xs tw-font-medium tw-flex-shrink-0" style={{ color: isDark ? '#aaa' : '#666' }}>x{post.quantity}</span>
        ) : null}

        {/* Price */}
        {!post.sold ? (
          <span className="tw-text-sm tw-font-bold tw-flex-shrink-0" style={{ color: '#c9a84c' }}>${(post.price || 0).toFixed(2)}</span>
        ) : null}

        {/* Edit button */}
        {isSelf && !post.sold ? (
          <button
            onClick={function() { self.openEditModal(post._id); }}
            className="tw-text-xs tw-px-3 tw-py-1.5 tw-rounded-lg tw-border tw-border-brand-gold tw-text-brand-gold tw-bg-transparent tw-cursor-pointer tw-flex-shrink-0 tw-transition-colors hover:tw-bg-brand-gold/10 tw-no-underline"
          >
            <i className="fa fa-pencil tw-mr-1"></i>Edit
          </button>
        ) : null}
      </div>
    );
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');

    if (this.state.loading) {
      return (
        <Layout>
          <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center">
            <div className="tw-animate-spin tw-rounded-full tw-h-12 tw-w-12 tw-border-t-2 tw-border-b-2 tw-border-brand-gold"></div>
          </div>
        </Layout>
      );
    }

    var activeListings = this.state.posts.filter(function(p) { return !p.sold; }).length;
    var soldListings = this.state.posts.filter(function(p) { return p.sold; }).length;
    var filteredPosts = this.state.posts;
    if (this.state.activeFilter === 'active') {
      filteredPosts = this.state.posts.filter(function(p) { return !p.sold; });
    } else if (this.state.activeFilter === 'sold') {
      filteredPosts = this.state.posts.filter(function(p) { return p.sold; });
    }

    // Category filter (by normalized condition, ignoring foil suffix)
    if (this.state.categoryFilter !== 'all') {
      var catFilter = this.state.categoryFilter;
      filteredPosts = filteredPosts.filter(function(p) { return getCondition(p.category) === catFilter; });
    }

    // Foil filter
    if (this.state.foilFilter) {
      filteredPosts = filteredPosts.filter(function(p) { return p.foil; });
    }

    // Search filter
    if (this.state.searchQuery) {
      var query = this.state.searchQuery.toLowerCase();
      filteredPosts = filteredPosts.filter(function(p) {
        return (p.title || '').toLowerCase().indexOf(query) !== -1;
      });
    }

    // Sort
    var sortBy = this.state.sortBy;
    filteredPosts = filteredPosts.slice().sort(function(a, b) {
      if (sortBy === 'price-low') return (a.price || 0) - (b.price || 0);
      if (sortBy === 'price-high') return (b.price || 0) - (a.price || 0);
      if (sortBy === 'alpha') return (a.title || '').localeCompare(b.title || '');
      return new Date(b.createdAt) - new Date(a.createdAt); // newest
    });

    // Get unique categories from current status-filtered posts (before search/category filter)
    var statusPosts = this.state.posts;
    if (this.state.activeFilter === 'active') {
      statusPosts = this.state.posts.filter(function(p) { return !p.sold; });
    } else if (this.state.activeFilter === 'sold') {
      statusPosts = this.state.posts.filter(function(p) { return p.sold; });
    }
    var categories = [];
    statusPosts.forEach(function(p) {
      var cond = getCondition(p.category);
      if (cond && categories.indexOf(cond) === -1) {
        categories.push(cond);
      }
    });
    categories.sort();
    var hasFoilListings = statusPosts.some(function(p) { return p.foil; });

    var visiblePosts = filteredPosts.slice(0, this.state.showItems);

    return (
      <Layout>
        <style>{`
          .follow-toggle-text { display: inline; }
          .follow-toggle-text::after { content: none; }
          button:hover .follow-toggle-text { font-size: 0; }
          button:hover .follow-toggle-text::after { font-size: 0.875rem; content: 'Unfollow'; }
        `}</style>
        <Helmet>
          <title>{this.state.username + "'s Shop"}</title>
          <meta name="description" content={this.state.bio} />
          <meta property="og:title" content={this.state.username + "'s Primal Marketplace Shop"} />
          <meta property="og:description" content={this.state.bio} />
          <meta property="og:image" content={this.state.profilePic} />
        </Helmet>

        {/* Profile Card */}
        <div className="tw-max-w-5xl tw-mx-auto tw-px-4 tw-pt-8">
          <div className="tw-rounded-2xl tw-p-6 md:tw-p-8 tw-relative" style={{
            backgroundColor: isDark ? '#1a1a1a' : '#fff',
            border: isDark ? '1px solid #2a2a2a' : '1px solid #e8e8e8',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 8px 24px rgba(0,0,0,0.04)',
          }}>
            <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center md:tw-items-start tw-gap-4 md:tw-gap-6">
              {/* Avatar */}
              <img
                src={this.state.profilePic}
                alt={this.state.username}
                className="tw-w-32 tw-h-32 tw-rounded-full tw-object-cover tw-border-4 tw-border-brand-gold tw-shadow-lg tw-flex-shrink-0 tw-bg-white dark:tw-bg-brand-dark"
              />

              {/* Name & Bio */}
              <div className="tw-flex-1 tw-text-center md:tw-text-left">
                <h1 className="tw-text-2xl tw-font-bold tw-text-[#111] dark:tw-text-white">{this.state.username}</h1>
                {this.state.verified && (
                  <div className="tw-flex tw-items-center tw-gap-1 tw-justify-center md:tw-justify-start tw-mt-0.5">
                    <svg className="tw-w-3.5 tw-h-3.5 tw-text-brand-gold" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="tw-text-xs tw-font-medium tw-text-brand-gold">Verified</span>
                  </div>
                )}
                {(this.state.reviews || []).length > 0 ? (
                <div
                  className="tw-flex tw-items-center tw-gap-2 tw-mt-2 tw-justify-center md:tw-justify-start tw-cursor-pointer"
                  onClick={this.toggleReviews}
                >
                  <StarRatingComponent
                    name="profileRating"
                    starCount={5}
                    starColor="#ffd788"
                    emptyStarColor="#939393"
                    value={this.state.rating}
                    editing={false}
                  />
                  <span className="tw-text-xs tw-text-[#888] hover:tw-text-brand-gold tw-transition-colors">
                    ({(this.state.reviews || []).length})
                    <i className={'fa tw-ml-1 tw-text-[10px] ' + (this.state.showReviews ? 'fa-chevron-up' : 'fa-chevron-down')} />
                  </span>
                </div>
                ) : (
                <p className="tw-text-xs tw-text-[#999] dark:tw-text-[#666] tw-mt-2 tw-mb-0 tw-text-center md:tw-text-left">No reviews yet</p>
                )}
                {this.state.bio ? (
                  <p className="tw-text-sm tw-text-[#666] dark:tw-text-[#aaa] tw-mt-2" style={{ whiteSpace: 'pre-wrap' }}>{this.state.bio}</p>
                ) : null}

                {/* Location, Shipping, Social */}
                {(this.state.preferredShipping || this.state.preferredPayment || this.state.instagram || this.state.twitter) ? (
                  <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-1.5 tw-mt-3 tw-text-sm tw-text-[#666] dark:tw-text-[#aaa]">
                    {this.state.preferredShipping ? (
                      <span><i className="fa fa-truck tw-mr-1.5 tw-text-brand-gold"></i>Ships via {this.state.preferredShipping}</span>
                    ) : null}
                    {this.state.preferredPayment && this.state.preferredPayment !== 'No Preference' ? (
                      <span><i className="fa fa-credit-card tw-mr-1.5 tw-text-brand-gold"></i>Accepts {this.state.preferredPayment}</span>
                    ) : null}
                    {this.state.instagram ? (
                      <a href={'https://instagram.com/' + this.state.instagram} target="_blank" rel="noopener noreferrer" className="tw-text-[#666] dark:tw-text-[#aaa] hover:tw-text-brand-gold tw-transition-colors tw-no-underline">
                        <i className="fa fa-instagram tw-mr-1"></i>@{this.state.instagram}
                      </a>
                    ) : null}
                    {this.state.twitter ? (
                      <a href={'https://x.com/' + this.state.twitter} target="_blank" rel="noopener noreferrer" className="tw-text-[#666] dark:tw-text-[#aaa] hover:tw-text-brand-gold tw-transition-colors tw-no-underline">
                        <i className="fa fa-twitter tw-mr-1"></i>@{this.state.twitter}
                      </a>
                    ) : null}
                  </div>
                ) : null}

                {/* Inline Reviews */}
                {this.state.showReviews && (this.state.reviews || []).length > 0 ? (
                  <div className="tw-mt-4 tw-pt-4" style={{ borderTop: isDark ? '1px solid #2a2a2a' : '1px solid #e5e5e5' }}>
                    {/* Sort pills */}
                    <div className="tw-flex tw-items-center tw-gap-1.5 tw-mb-3">
                      {[
                        { key: 'newest', label: 'Newest' },
                        { key: 'oldest', label: 'Oldest' },
                        { key: 'highest', label: 'Best' },
                        { key: 'lowest', label: 'Critical' },
                      ].map(function(opt) {
                        var isActive = self.state.reviewSort === opt.key;
                        return (
                          <button
                            key={opt.key}
                            onClick={function() { self.setState({ reviewSort: opt.key }); }}
                            className="tw-px-2.5 tw-py-1 tw-rounded-full tw-text-[11px] tw-font-medium tw-border-none tw-cursor-pointer"
                            style={isActive
                              ? { backgroundColor: '#c9a84c', color: '#fff', boxShadow: '0 2px 8px rgba(201,168,76,0.3)', transition: 'all 0.2s ease' }
                              : { backgroundColor: 'transparent', color: '#999', transition: 'all 0.2s ease' }
                            }
                          >
                            {opt.label}
                          </button>
                        );
                      })}
                      <span className="tw-text-[11px] tw-ml-auto" style={{ color: '#bbb' }}>{this.state.reviews.length} review{this.state.reviews.length !== 1 ? 's' : ''}</span>
                    </div>
                    {/* Review list */}
                    <div style={{ maxHeight: this.state.showAllReviews ? '500px' : 'none', overflowY: this.state.showAllReviews ? 'auto' : 'visible' }}>
                      {(function() {
                        var sorted = self.state.reviews.slice().sort(function(a, b) {
                          if (self.state.reviewSort === 'oldest') return new Date(a.createdAt) - new Date(b.createdAt);
                          if (self.state.reviewSort === 'highest') return b.rating - a.rating;
                          if (self.state.reviewSort === 'lowest') return a.rating - b.rating;
                          return new Date(b.createdAt) - new Date(a.createdAt);
                        });
                        return self.state.showAllReviews ? sorted : sorted.slice(0, 5);
                      })().map(function(review, idx, arr) {
                        var buyerName = review.buyer && review.buyer.userName ? review.buyer.userName : 'Buyer';
                        var buyerImg = review.buyer && (review.buyer.image || review.buyer.picture);
                        var buyerImage = buyerImg
                          ? constants.DOMAIN + '/' + buyerImg
                          : null;
                        var date = review.createdAt ? new Date(review.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
                        var stars = '';
                        for (var s = 0; s < 5; s++) { stars += s < review.rating ? '\u2605' : '\u2606'; }
                        return (
                          <div key={review._id || idx}>
                            <div className="tw-flex tw-gap-2.5 tw-py-3">
                              {buyerImage ? (
                                <img src={buyerImage} alt={buyerName} className="tw-w-7 tw-h-7 tw-rounded-full tw-object-cover tw-flex-shrink-0" />
                              ) : (
                                <div className="tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ background: isDark ? '#2a2a2a' : '#f0f0f0' }}>
                                  <span className="tw-text-[11px] tw-font-bold tw-text-[#999]">{buyerName.charAt(0)}</span>
                                </div>
                              )}
                              <div className="tw-flex-1 tw-min-w-0">
                                <div className="tw-flex tw-items-center tw-gap-2">
                                  <span className="tw-text-[13px] tw-font-medium tw-text-[#111] dark:tw-text-white">{buyerName}</span>
                                  <span className="tw-text-[11px] tw-text-[#bbb]">{date}</span>
                                  <span className="tw-text-[12px] tw-ml-auto" style={{ color: '#c9a84c', letterSpacing: '-1px' }}>{stars}</span>
                                </div>
                                <p className="tw-text-[13px] tw-text-[#555] dark:tw-text-[#bbb] tw-mt-0.5 tw-leading-snug">{review.review}</p>
                              </div>
                            </div>
                            {idx < arr.length - 1 ? <div style={{ height: '1px', background: isDark ? '#2a2a2a' : '#f0f0f0' }}></div> : null}
                          </div>
                        );
                      })}
                    </div>
                    {!this.state.showAllReviews && this.state.reviews.length > 5 ? (
                      <button
                        onClick={function() { self.setState({ showAllReviews: true }); }}
                        className="tw-mt-2 tw-text-[13px] tw-text-brand-gold hover:tw-underline tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-0"
                      >
                        View all {this.state.reviews.length} reviews
                      </button>
                    ) : null}
                  </div>
                ) : null}
                {this.state.showReviews && (this.state.reviews || []).length === 0 ? (
                  <div className="tw-mt-4 tw-pt-4" style={{ borderTop: isDark ? '1px solid #2a2a2a' : '1px solid #e5e5e5' }}>
                    <p className="tw-text-sm" style={{ color: isDark ? '#666' : '#999' }}>No reviews yet</p>
                  </div>
                ) : null}
              </div>

              {/* Action Buttons */}
              <div className="tw-flex-shrink-0">
                {this.state.isSelf && Auth.getToken() ? (
                  <div className="tw-flex tw-flex-col tw-gap-2">
                    <Link
                      to="/settings"
                      className="tw-inline-block tw-px-6 tw-py-2.5 tw-rounded-lg tw-border tw-border-brand-gold tw-text-brand-gold tw-font-medium tw-text-sm hover:tw-bg-brand-gold/10 tw-transition-colors tw-no-underline tw-text-center"
                    >
                      <i className="fa fa-pencil tw-mr-2"></i>Edit Profile
                    </Link>
                    <button
                      onClick={this.toggleShopActive}
                      disabled={this.state.togglingShop}
                      className={'tw-px-6 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-medium tw-border tw-cursor-pointer tw-transition-colors ' + (this.state.shopActive ? 'tw-border-[#ddd] dark:tw-border-[#333] tw-bg-transparent tw-text-[#666] dark:tw-text-[#999] hover:tw-border-red-400 hover:tw-text-red-500' : 'tw-border-brand-gold tw-bg-brand-gold tw-text-black hover:tw-bg-brand-gold-dark')}
                    >
                      <i className={'fa tw-mr-1.5 ' + (this.state.shopActive ? 'fa-pause' : 'fa-play')}></i>
                      {this.state.togglingShop ? (this.state.shopActive ? 'Closing...' : 'Opening...') : (this.state.shopActive ? 'Close Shop' : 'Open Shop')}
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={this.handleFollow}
                    className={
                      'tw-px-6 tw-py-2.5 tw-rounded-lg tw-font-medium tw-text-sm tw-border tw-cursor-pointer tw-transition-colors tw-flex tw-items-center tw-gap-1.5 ' +
                      (this.state.isFollowing
                        ? 'tw-bg-brand-gold/10 tw-border-brand-gold tw-text-brand-gold hover:tw-bg-red-500/10 hover:tw-border-red-500 hover:tw-text-red-500'
                        : 'tw-bg-brand-gold tw-border-brand-gold tw-text-black hover:tw-bg-brand-gold-dark')
                    }
                  >
                    <i className={this.state.isFollowing ? 'fa fa-check' : 'fa fa-plus'} />
                    <span className={this.state.isFollowing ? 'follow-toggle-text' : ''}>
                      {this.state.isFollowing ? 'Following' : 'Follow'}
                    </span>
                  </button>
                )}
              </div>
            </div>

            {/* Stats Row — Inside Card */}
            <div className="tw-flex tw-items-center tw-justify-center md:tw-justify-start tw-mt-6 tw-pt-6" style={{ borderTop: isDark ? '1px solid #2a2a2a' : '1px solid #e0e0e0' }}>
              <div className="tw-text-center tw-px-4 md:tw-px-6">
                <p className="tw-text-lg tw-font-bold tw-mb-0" style={{ color: isDark ? '#fff' : '#111' }}>{activeListings}</p>
                <p className="tw-text-xs tw-mb-0" style={{ color: '#888' }}>Active</p>
              </div>
              <div style={{ width: '1px', height: '32px', background: isDark ? '#333' : '#ddd' }}></div>
              <div className="tw-text-center tw-px-4 md:tw-px-6">
                <p className="tw-text-lg tw-font-bold tw-mb-0" style={{ color: isDark ? '#fff' : '#111' }}>{soldListings}</p>
                <p className="tw-text-xs tw-mb-0" style={{ color: '#888' }}>Sold</p>
              </div>
              <div style={{ width: '1px', height: '32px', background: isDark ? '#333' : '#ddd' }}></div>
              <div onClick={function() { self.openFollowModal('following'); }} className="tw-text-center tw-px-4 md:tw-px-6 tw-cursor-pointer" style={{ transition: 'opacity 0.15s ease' }}
                onMouseEnter={function(e) { e.currentTarget.style.opacity = '0.7'; }}
                onMouseLeave={function(e) { e.currentTarget.style.opacity = '1'; }}
              >
                <p className="tw-text-lg tw-font-bold tw-mb-0" style={{ color: isDark ? '#fff' : '#111' }}>{this.state.following.length}</p>
                <p className="tw-text-xs tw-mb-0" style={{ color: '#888' }}>Following</p>
              </div>
              <div style={{ width: '1px', height: '32px', background: isDark ? '#333' : '#ddd' }}></div>
              <div onClick={function() { self.openFollowModal('followers'); }} className="tw-text-center tw-px-4 md:tw-px-6 tw-cursor-pointer" style={{ transition: 'opacity 0.15s ease' }}
                onMouseEnter={function(e) { e.currentTarget.style.opacity = '0.7'; }}
                onMouseLeave={function(e) { e.currentTarget.style.opacity = '1'; }}
              >
                <p className="tw-text-lg tw-font-bold tw-mb-0" style={{ color: isDark ? '#fff' : '#111' }}>{this.state.followers.length}</p>
                <p className="tw-text-xs tw-mb-0" style={{ color: '#888' }}>Followers</p>
              </div>
              {formatDate(this.state.createdAt) ? (
                <div className="tw-flex tw-items-center">
                  <div style={{ width: '1px', height: '32px', background: isDark ? '#333' : '#ddd' }}></div>
                  <div className="tw-text-center tw-px-4 md:tw-px-6">
                    <p className="tw-text-lg tw-font-bold tw-mb-0" style={{ color: isDark ? '#fff' : '#111' }}>{formatDate(this.state.createdAt)}</p>
                    <p className="tw-text-xs tw-mb-0" style={{ color: '#888' }}>Member Since</p>
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          {/* Shop Closed Notice */}
          {!this.state.shopActive && (
            <div className="tw-mt-4 tw-rounded-lg tw-py-3 tw-px-4 tw-text-center tw-border" style={{ backgroundColor: 'rgba(201, 168, 76, 0.08)', borderColor: 'rgba(201, 168, 76, 0.25)' }}>
              <p className="tw-text-sm tw-font-medium tw-mb-0" style={{ color: '#a08530' }}>
                <i className="fa fa-pause-circle tw-mr-2" />
                {this.state.isSelf && Auth.getToken()
                  ? 'Your shop is closed. Listings are hidden from search and browse.'
                  : 'This shop is currently closed'}
              </p>
            </div>
          )}

          {/* Filter Tabs */}
          <div className="tw-flex tw-items-center tw-gap-2 tw-mt-4 tw-overflow-x-auto tw-pb-1">
            {[
              { key: 'all', label: 'All (' + this.state.posts.length + ')' },
              { key: 'active', label: 'Active (' + activeListings + ')' },
              { key: 'sold', label: 'Sold (' + soldListings + ')' },
            ].map(function(tab) {
              var isActive = self.state.activeFilter === tab.key;
              return (
                <button
                  key={tab.key}
                  onClick={function() { self.handleFilterChange(tab.key); }}
                  className="tw-px-4 tw-py-2 tw-rounded-full tw-text-sm tw-font-medium tw-border-none tw-cursor-pointer tw-whitespace-nowrap"
                  style={isActive
                    ? { backgroundColor: '#c9a84c', color: '#000', boxShadow: '0 2px 8px rgba(201,168,76,0.3)', transition: 'all 0.2s ease' }
                    : { backgroundColor: isDark ? '#2a2a2a' : '#f0f0f0', color: isDark ? '#999' : '#666', transition: 'all 0.2s ease' }
                  }
                >
                  {tab.label}
                </button>
              );
            })}
            {/* BUYLIST FEATURE: disabled — preserved for future use */}
            {/* <button
              onClick={function() { self.handleFilterChange('buying'); }}
              className={'tw-px-4 tw-py-2 tw-rounded-full tw-text-sm tw-font-medium tw-border-none tw-cursor-pointer tw-transition-colors tw-whitespace-nowrap ' + (this.state.activeFilter === 'buying' ? 'tw-bg-brand-gold tw-text-black' : 'tw-bg-[#f0f0f0] dark:tw-bg-[#2a2a2a] tw-text-[#666] dark:tw-text-[#999] hover:tw-bg-[#e5e5e5] dark:hover:tw-bg-[#333]')}
            >
              Buying ({this.state.buylistCount})
            </button> */}
          </div>

          {/* BUYLIST FEATURE: disabled — preserved for future use
          {this.state.activeFilter === 'buying' ? (
            <BuylistTab userId={this.state.id} isSelf={this.state.isSelf} history={this.props.history} />
          ) : ( */}
          <div>
          {/* Search & Sort */}
          <div className="tw-flex tw-flex-col sm:tw-flex-row tw-items-stretch sm:tw-items-center tw-gap-3 tw-mt-3">
            <div className="tw-relative tw-flex-1">
              <i className="fa fa-search tw-absolute tw-text-[#999] tw-text-sm" style={{ left: '12px', top: '50%', transform: 'translateY(-50%)' }}></i>
              <input
                type="text"
                placeholder="Search listings..."
                value={this.state.searchQuery}
                onChange={function(e) { self.setState({ searchQuery: e.target.value, showItems: 20 }); }}
                className="tw-w-full tw-pr-3 tw-py-3 tw-rounded-xl tw-text-sm tw-outline-none focus:tw-border-brand-gold tw-transition-colors"
                style={{ paddingLeft: '36px', backgroundColor: isDark ? '#1a1a1a' : '#fff', border: isDark ? '1px solid #333' : '1px solid #ddd', color: isDark ? '#fff' : '#111' }}
              />
            </div>
            <select
              value={this.state.sortBy}
              onChange={function(e) { self.setState({ sortBy: e.target.value }); }}
              className="tw-px-5 tw-py-3 tw-rounded-xl tw-text-sm tw-outline-none focus:tw-border-brand-gold tw-cursor-pointer tw-transition-colors"
              style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: isDark ? '1px solid #333' : '1px solid #ddd', color: isDark ? '#fff' : '#111' }}
            >
              <option value="newest">Newest</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
              <option value="alpha">A - Z</option>
            </select>
            {/* Grid / List toggle */}
            <div className="tw-flex tw-rounded-xl tw-overflow-hidden" style={{ border: isDark ? '1px solid #333' : '1px solid #ddd' }}>
              <button
                onClick={function() { self.setState({ viewMode: 'grid' }); }}
                className="tw-px-3 tw-py-3 tw-border-none tw-cursor-pointer tw-transition-colors tw-flex tw-items-center tw-justify-center"
                style={{ backgroundColor: self.state.viewMode === 'grid' ? '#c9a84c' : (isDark ? '#1a1a1a' : '#fff'), color: self.state.viewMode === 'grid' ? '#000' : (isDark ? '#999' : '#666') }}
                title="Grid view"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <rect x="0" y="0" width="7" height="7" rx="1" />
                  <rect x="9" y="0" width="7" height="7" rx="1" />
                  <rect x="0" y="9" width="7" height="7" rx="1" />
                  <rect x="9" y="9" width="7" height="7" rx="1" />
                </svg>
              </button>
              <button
                onClick={function() { self.setState({ viewMode: 'list' }); }}
                className="tw-px-3 tw-py-3 tw-border-none tw-cursor-pointer tw-transition-colors tw-flex tw-items-center tw-justify-center"
                style={{ backgroundColor: self.state.viewMode === 'list' ? '#c9a84c' : (isDark ? '#1a1a1a' : '#fff'), color: self.state.viewMode === 'list' ? '#000' : (isDark ? '#999' : '#666'), borderLeft: isDark ? '1px solid #333' : '1px solid #ddd' }}
                title="List view"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <rect x="0" y="0" width="16" height="3" rx="1" />
                  <rect x="0" y="4.5" width="16" height="3" rx="1" />
                  <rect x="0" y="9" width="16" height="3" rx="1" />
                  <rect x="0" y="13" width="16" height="3" rx="1" />
                </svg>
              </button>
            </div>
          </div>

          {/* Condition Pills & Foil Toggle */}
          {categories.length > 1 || hasFoilListings ? (
            <div className="tw-flex tw-items-center tw-gap-2 tw-mt-3 tw-overflow-x-auto tw-pb-1">
              {categories.length > 1 ? (
                <button
                  onClick={function() { self.setState({ categoryFilter: 'all', showItems: 20 }); }}
                  className="tw-px-3 tw-py-1.5 tw-rounded-full tw-text-xs tw-font-medium tw-border-none tw-cursor-pointer tw-whitespace-nowrap"
                  style={self.state.categoryFilter === 'all'
                    ? { backgroundColor: isDark ? '#fff' : '#111', color: isDark ? '#000' : '#fff', transition: 'all 0.2s ease' }
                    : { backgroundColor: isDark ? '#2a2a2a' : '#f0f0f0', color: isDark ? '#999' : '#666', transition: 'all 0.2s ease' }
                  }
                >
                  All Conditions
                </button>
              ) : null}
              {categories.length > 1 ? categories.map(function(cat) {
                var isCatActive = self.state.categoryFilter === cat;
                return (
                  <button
                    key={cat}
                    onClick={function() { self.setState({ categoryFilter: cat, showItems: 20 }); }}
                    className="tw-px-3 tw-py-1.5 tw-rounded-full tw-text-xs tw-font-medium tw-border-none tw-cursor-pointer tw-whitespace-nowrap"
                    style={isCatActive
                      ? { backgroundColor: isDark ? '#fff' : '#111', color: isDark ? '#000' : '#fff', transition: 'all 0.2s ease' }
                      : { backgroundColor: isDark ? '#2a2a2a' : '#f0f0f0', color: isDark ? '#999' : '#666', transition: 'all 0.2s ease' }
                    }
                  >
                    {formatCondition(cat)}
                  </button>
                );
              }) : null}
              {hasFoilListings ? (
                <button
                  onClick={function() { self.setState({ foilFilter: !self.state.foilFilter, showItems: 20 }); }}
                  className="tw-px-3 tw-py-1.5 tw-rounded-full tw-text-xs tw-font-medium tw-border-none tw-cursor-pointer tw-whitespace-nowrap"
                  style={self.state.foilFilter
                    ? { backgroundColor: '#c9a84c', color: '#000', boxShadow: '0 2px 8px rgba(201,168,76,0.3)', transition: 'all 0.2s ease' }
                    : { backgroundColor: isDark ? '#2a2a2a' : '#f0f0f0', color: isDark ? '#999' : '#666', transition: 'all 0.2s ease' }
                  }
                >
                  <i className="fa fa-star tw-mr-1"></i>Foil
                </button>
              ) : null}
            </div>
          ) : null}

          {/* Listings Grid / List */}
          <div className="tw-py-6">
            {visiblePosts.length > 0 ? (
              self.state.viewMode === 'list' ? (
                <div className="tw-rounded-xl tw-overflow-hidden" style={Object.assign({ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: isDark ? '1px solid #2a2a2a' : '1px solid #eee' }, !this.state.shopActive ? { opacity: 0.5, filter: 'grayscale(40%)' } : {})}>
                  {visiblePosts.map(function(post) {
                    return self.renderListRow(post);
                  })}
                </div>
              ) : (
                <div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-3 sm:tw-gap-4 tw-items-start" style={!this.state.shopActive ? { opacity: 0.5, filter: 'grayscale(40%)' } : {}}>
                  {arrangeCardsForGrid(visiblePosts, 4).map(function(post) {
                    return self.renderListingCard(post);
                  })}
                </div>
              )
            ) : (
              <div className="tw-text-center tw-py-16">
                <div className="tw-w-16 tw-h-16 tw-mx-auto tw-mb-4 tw-rounded-full tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: isDark ? '#222' : '#f5f5f5' }}>
                  <i className="fa fa-tag tw-text-2xl" style={{ color: isDark ? '#555' : '#c9a84c' }}></i>
                </div>
                {this.state.isSelf && Auth.getToken() ? (
                  <div>
                    <p className="tw-text-[#666] dark:tw-text-[#999] tw-font-medium">List your first item</p>
                    <p className="tw-text-sm tw-text-[#999] dark:tw-text-[#666] tw-mt-1">Start selling by creating your first listing</p>
                    <Link
                      to="/sell"
                      className="tw-inline-block tw-mt-4 tw-px-6 tw-py-2.5 tw-rounded-lg tw-bg-brand-gold tw-text-black tw-font-medium tw-text-sm hover:tw-bg-brand-gold-dark tw-transition-colors tw-no-underline"
                    >
                      <i className="fa fa-plus tw-mr-2"></i>Create Listing
                    </Link>
                  </div>
                ) : (
                  <p className="tw-text-[#999] dark:tw-text-[#666]">No listings yet</p>
                )}
              </div>
            )}

            {/* Show More */}
            {filteredPosts.length > 0 ? (
              <div className="tw-text-center tw-mt-8">
                <p className="tw-text-xs tw-text-[#999] dark:tw-text-[#666] tw-mb-3">
                  Showing {Math.min(visiblePosts.length, filteredPosts.length)} of {filteredPosts.length} listings
                </p>
                {this.state.showItems < filteredPosts.length ? (
                  <button
                    onClick={this.handleShowMore}
                    className="tw-px-8 tw-py-3 tw-rounded-lg tw-border tw-border-brand-gold tw-text-brand-gold tw-bg-transparent tw-font-semibold tw-text-sm tw-cursor-pointer hover:tw-bg-brand-gold/10 tw-transition-colors"
                  >
                    Show More
                  </button>
                ) : null}
              </div>
            ) : null}
          </div>
          </div>
          {/* BUYLIST: closing ternary was here — removed with buylist disable */}
        </div>

        {/* Edit Modal */}
        {this.state.editModalPost ? this.renderEditModal() : null}

        {/* Followers / Following Modal */}
        {this.state.followModal ? (
          <div className="tw-fixed tw-inset-0 tw-z-[9999] tw-flex tw-items-center tw-justify-center" onClick={function() { self.setState({ followModal: null }); }}>
            <div className="tw-absolute tw-inset-0 tw-bg-black/50" style={{ backdropFilter: 'blur(4px)' }} />
            <div className="modal-enter tw-relative tw-rounded-xl tw-w-full tw-max-w-md tw-mx-4 tw-max-h-[70vh] tw-flex tw-flex-col" style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.3)', backgroundColor: isDark ? '#1a1a1a' : '#fff' }} onClick={function(e) { e.stopPropagation(); }}>
              <div className="tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-4" style={{ borderBottom: isDark ? '1px solid #333' : '1px solid #eee' }}>
                <h3 className="tw-text-lg tw-font-bold tw-m-0" style={{ color: isDark ? '#fff' : '#111' }}>
                  {this.state.followModal === 'followers' ? 'Followers' : 'Following'}
                </h3>
                <button onClick={function() { self.setState({ followModal: null }); }} className="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xl tw-p-1" style={{ color: '#888', transition: 'color 0.15s ease' }}
                  onMouseEnter={function(e) { e.currentTarget.style.color = isDark ? '#fff' : '#111'; }}
                  onMouseLeave={function(e) { e.currentTarget.style.color = '#888'; }}
                >
                  <i className="fa fa-times" />
                </button>
              </div>
              <div className="tw-overflow-y-auto tw-flex-1 tw-p-4">
                {this.state.followModalLoading ? (
                  <div className="tw-text-center tw-py-8">
                    <i className="fa fa-spinner fa-spin tw-text-2xl tw-text-brand-gold" />
                  </div>
                ) : this.state.followModalData.length === 0 ? (
                  <p className="tw-text-center tw-py-8 tw-m-0" style={{ color: '#888' }}>
                    {this.state.followModal === 'followers' ? 'No followers yet' : 'Not following anyone yet'}
                  </p>
                ) : (
                  this.state.followModalData.map(function(user) {
                    return (
                      <Link key={user._id} to={'/shop/' + user.userName} onClick={function() { self.setState({ followModal: null }); }} className="tw-flex tw-items-center tw-gap-3 tw-py-3 tw-px-2 tw-rounded-lg tw-no-underline last:tw-border-0" style={{ borderBottom: isDark ? '1px solid #2a2a2a' : '1px solid #f0f0f0', transition: 'background-color 0.15s ease' }}
                        onMouseEnter={function(e) { e.currentTarget.style.backgroundColor = isDark ? '#252525' : '#f5f5f5'; }}
                        onMouseLeave={function(e) { e.currentTarget.style.backgroundColor = 'transparent'; }}
                      >
                        <img
                          src={user.image && user.image.indexOf('http') === 0 ? user.image : constants.DOMAIN + '/' + user.image}
                          alt={user.userName}
                          className="tw-w-11 tw-h-11 tw-rounded-full tw-object-cover tw-border-2 tw-border-brand-gold/30"
                          onError={function(e) { e.target.src = 'https://static.productionready.io/images/smiley-cyrus.jpg'; }}
                        />
                        <div className="tw-flex-1 tw-min-w-0">
                          <p className="tw-font-semibold tw-text-sm tw-m-0 tw-truncate" style={{ color: isDark ? '#fff' : '#111' }}>@{user.userName}</p>
                        </div>
                        {user.rating > 0 ? (
                          <div className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-brand-gold">
                            <i className="fa fa-star" />
                            <span>{user.rating.toFixed(1)}</span>
                          </div>
                        ) : null}
                      </Link>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        ) : null}

        {/* Scroll to top button */}
        {this.state.showBackToTop ? (
          <button
            onClick={function() { window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="tw-fixed tw-bottom-6 tw-right-6 tw-w-10 tw-h-10 tw-rounded-full tw-bg-brand-gold tw-text-black tw-border-0 tw-cursor-pointer tw-z-40 tw-flex tw-items-center tw-justify-center mobile-tab-offset-btn"
            style={{ boxShadow: '0 4px 16px rgba(201, 168, 76, 0.3)', animation: 'hp-fadeUp 0.3s ease forwards' }}
            aria-label="Scroll to top"
          >
            <svg className="tw-w-6 tw-h-6" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
          </button>
        ) : null}
      </Layout>
    );
  }
}

export default Profile;
